import {
  createResource,
  deleteResource,
  postFormDataPrettifierResource,
  postResource,
} from '@resource/resource'

import { prefixAPI } from '@resource/api'

const MODEL = 'store/product'
const MODEL_EQUIPMENT = 'equipment'

const PRODUCT_CONSUMPTION_URL = prefixAPI('/price-per-serving/{id}/', MODEL)
const PRODUCT_PACKAGES_LIST_URL = prefixAPI('/packages/{?offset,limit}', MODEL)

const SEARCH_FILTERS_URL = prefixAPI('search-filter/{?category,offset,limit}')

const RESULT_CREATE_URL = prefixAPI('/result/create/', MODEL)
const RESULT_LIST_URL = prefixAPI('/result/list/{?id}', MODEL)
const RESULT_IMAGE_CREATE_URL = prefixAPI('/result/image/create/', MODEL)
const RESULT_IMAGE_DESTROY_URL = prefixAPI('/result/image/destroy/{id}/', MODEL)

const RESULT_PATIENT_CONSENT_CREATE_URL = prefixAPI('/result/patient-consent/create/', MODEL)
const RESULT_PATIENT_CONSENT_DESTROY_URL = prefixAPI('/result/patient-consent/destroy/{id}/', MODEL)

const EQUIPMENT_RESULT_CREATE_URL = prefixAPI('/result/create/', MODEL_EQUIPMENT)
const EQUIPMENT_RESULT_LIST_URL = prefixAPI('/result/list/{?id}', MODEL_EQUIPMENT)
const EQUIPMENT_RESULT_IMAGE_CREATE_URL = prefixAPI('/result/image/create/', MODEL_EQUIPMENT)
const EQUIPMENT_RESULT_IMAGE_DESTROY_URL = prefixAPI('/result/image/destroy/{id}/', MODEL_EQUIPMENT)

const EQUIPMENT_RESULT_PATIENT_CONSENT_CREATE_URL = prefixAPI('/result/patient-consent/create/', MODEL_EQUIPMENT)
const EQUIPMENT_RESULT_PATIENT_CONSENT_DESTROY_URL = prefixAPI('/result/patient-consent/destroy/{id}/', MODEL_EQUIPMENT)

const GROUP_PARAMETERS_GROUPS_URL = prefixAPI('/group-parameter/groups/{id}/{?limit}', MODEL)
export const GROUP_PARAMETERS_PRODUCT_URL = prefixAPI('/group-parameter/product/{id}/{?group_ids,search}', MODEL)

const LOST_PROFIT_URL = prefixAPI('lost-profit/create-update/')
const PREORDER_LIST_URL = prefixAPI('store/preorder/list/{?country_available__iso_code,limit,offset}')

export const getProductConsumption = createResource(PRODUCT_CONSUMPTION_URL)
export const getPackagesList = createResource(PRODUCT_PACKAGES_LIST_URL)

export const getSearchFilters = createResource(SEARCH_FILTERS_URL)

export const ResultCreate = createResource(RESULT_CREATE_URL, postResource)
export const ResultList = createResource(RESULT_LIST_URL)
export const ResultImageCreate = createResource(RESULT_IMAGE_CREATE_URL, postFormDataPrettifierResource)
export const ResultImageDestroy = createResource(RESULT_IMAGE_DESTROY_URL, deleteResource)

export const ResultPatientConsentCreate = createResource(RESULT_PATIENT_CONSENT_CREATE_URL, postFormDataPrettifierResource)
export const ResultPatientConsentDestroy = createResource(RESULT_PATIENT_CONSENT_DESTROY_URL, deleteResource)

export const EquipmentResultCreate = createResource(EQUIPMENT_RESULT_CREATE_URL, postResource)
export const EquipmentResultList = createResource(EQUIPMENT_RESULT_LIST_URL)
export const EquipmentResultImageCreate = createResource(EQUIPMENT_RESULT_IMAGE_CREATE_URL, postFormDataPrettifierResource)
export const EquipmentResultImageDestroy = createResource(EQUIPMENT_RESULT_IMAGE_DESTROY_URL, deleteResource)

export const EquipmentResultPatientConsentCreate = createResource(EQUIPMENT_RESULT_PATIENT_CONSENT_CREATE_URL, postFormDataPrettifierResource)
export const EquipmentResultPatientConsentDestroy = createResource(EQUIPMENT_RESULT_PATIENT_CONSENT_DESTROY_URL, deleteResource)

export const LostProfitResource = createResource(LOST_PROFIT_URL, postResource)

export const PreorderList = createResource(PREORDER_LIST_URL)

export const GroupParametersGroupsResource = createResource(GROUP_PARAMETERS_GROUPS_URL)
export const GroupParametersProductsResource = createResource(GROUP_PARAMETERS_PRODUCT_URL)
